module["exports"] = [
  "0###",
  "2###",
  "3###",
  "4###",
  "5###",
  "6###",
  "7###"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_AU/address/postcode.js
// module id = 1699
// module chunks = 0